// Companysettings codes for the restaurant's "new order email" notification.
// Must match OrderNotificationPolicy on the API.
export const ORDER_NOTIFICATION_CODES = {
  ENABLED: 'order_notification_enabled',
  EMAIL: 'order_notification_email',
  FILTER: 'order_notification_filter',
};

export const ORDER_NOTIFICATION_FILTERS = ['all', 'asap', 'scheduled'];

const settingValue = (settingsMap, code) => settingsMap?.[code]?.value ?? '';

export const readOrderNotificationSettings = (settingsMap) => {
  const enabled =
    settingValue(settingsMap, ORDER_NOTIFICATION_CODES.ENABLED)
      .trim()
      .toLowerCase() === 'true';

  const email = settingValue(settingsMap, ORDER_NOTIFICATION_CODES.EMAIL).trim();

  const storedFilter = settingValue(settingsMap, ORDER_NOTIFICATION_CODES.FILTER)
    .trim()
    .toLowerCase();
  const filter = ORDER_NOTIFICATION_FILTERS.includes(storedFilter)
    ? storedFilter
    : 'all';

  return { enabled, email, filter };
};

export const isValidNotificationEmail = (value) => {
  const email = (value || '').trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

// CompanySetting/Create rejects codes that already have a row (and Update
// rejects ones that don't), so changes are split by what the map holds.
export const splitSettingsForSave = (settingsMap, changes) => {
  const toCreate = [];
  const toUpdate = [];
  Object.entries(changes).forEach(([code, value]) => {
    const target = settingsMap?.[code] ? toUpdate : toCreate;
    target.push({ code, value: String(value) });
  });
  return { toCreate, toUpdate };
};
